import { render, staticRenderFns } from "./createJoin1.vue?vue&type=template&id=137bbaf5&scoped=true&"
import script from "./createJoin1.vue?vue&type=script&lang=js&"
export * from "./createJoin1.vue?vue&type=script&lang=js&"
import style0 from "./createJoin1.vue?vue&type=style&index=0&id=137bbaf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bbaf5",
  null
  
)

export default component.exports